/* 🤖 this file was generated by svg-to-ts */
export const matIconKeyboardArrowRight: {
  name: 'keyboard-arrow-right';
  data: string;
} = {
  name: 'keyboard-arrow-right',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M8.59 16.59 13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"/></svg>`
};
